import React from "react";
import { AiFillHeart } from "react-icons/ai";
import { AiFillInstagram } from "react-icons/ai";
import { AiFillLinkedin } from "react-icons/ai";
import { AiOutlineTwitter } from "react-icons/ai";
import { AiFillGithub } from "react-icons/ai";
import { SiHashnode } from "react-icons/si";
import * as C from "./styles";

const Footer = () => {
  return (
    <C.Container>
      <C.FollowMe>
        <p>Fale Comigo:</p>
        <C.Network>
          <a
            href="https://www.linkedin.com/in/gabriel07-oliveira-santos"
            about="Meu Linkdin"
          >
            <AiFillLinkedin className="icons" />
          </a>
          <a href="https://github.com/GabrielSantos07" about="Meu Github">
            <AiFillGithub className="icons" />
          </a>
          <a href="https://twitter.com/Biel_OliveiraS_" about="Meu Twitter">
            <AiOutlineTwitter className="icons" />
          </a>
          <a
            href="https://www.instagram.com/biel_oliveiras_/"
            about="Meu Instagram"
          >
            <AiFillInstagram className="icons" />
          </a>
          <a href="https://hashnode.com/@GabrielOliveira" about="Meu Blog">
            <SiHashnode className="icons" />
          </a>
        </C.Network>
      </C.FollowMe>

      <C.Creator>
        <p>
          Feito com <AiFillHeart className="heart" />
          por Gabriel
        </p>
      </C.Creator>
    </C.Container>
  );
};

export default Footer;
